/**
 * HelpMenu — top-bar "?" dropdown.
 *
 * The old icon had no onClick, so clicking it silently did nothing
 * (caught in the Feb 2026 sign-up UX walk-through). This restores
 * actual help affordances:
 *   - Take a product tour (re-launches the first-run coach marks)
 *   - Keyboard shortcuts (links to in-app reference)
 *   - Contact support → /support
 *   - Status page → opens externally
 */
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import {
  DropdownMenu, DropdownMenuTrigger, DropdownMenuContent,
  DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator,
} from './ui/dropdown-menu';
import {
  HelpCircle, MessagesSquare, Compass,
  BookOpen, ExternalLink,
} from 'lucide-react';

export default function HelpMenu() {
  const launchTour = () => {
    // OnboardingTour listens for this event and resets its "seen" flag.
    try { window.localStorage.removeItem('onboarding_tour_done_v1'); } catch { /* ignore */ }
    window.dispatchEvent(new Event('onboarding-tour-start'));
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          className="hidden sm:flex"
          aria-label="Help"
          data-testid="topbar-help-btn"
        >
          <HelpCircle className="w-5 h-5 text-muted-foreground" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-56" data-testid="help-menu">
        <DropdownMenuLabel>Help &amp; Resources</DropdownMenuLabel>
        <DropdownMenuSeparator />

        <DropdownMenuItem onClick={launchTour} data-testid="help-take-tour">
          <Compass className="w-4 h-4 mr-2" />
          Take a product tour
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link to="/support" data-testid="help-contact-support">
            <MessagesSquare className="w-4 h-4 mr-2" />
            Contact support
          </Link>
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem asChild>
          <a
            href="https://countbucks.com/docs"
            target="_blank"
            rel="noreferrer"
            data-testid="help-docs"
          >
            <BookOpen className="w-4 h-4 mr-2" />
            Documentation
            <ExternalLink className="w-3 h-3 ml-auto opacity-60" />
          </a>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
